/**
 * A.D.B. - 17-11-2022
 * Auth hooks module used to fix oidc-auth accesstoken renewal
 * handle unintended disconnections and auto restore sessions
 */

import { rapsotecClient } from "@/api/rapsotecClient";
import router from "@/router";
import { useAuth, useOidcStore } from "vue3-oidc";
const auth = useAuth();
export const redirectLogin = async () => {
  console.log("redirect login page");
  useOidcStore().actions.value.removeUser();

  auth.signinRedirect({
    redirect_uri: router.currentRoute.value.fullPath,
  });
};

export const tryRefreshSessionOrRedirect = async () => {
  try {
    if (!useOidcStore().state.value.user) {
      await auth.autoAuthenticate();
    } else {
      const updatedOidcUser =
        await useOidcStore().state.value.userManager?.signinSilent();
      if (updatedOidcUser) {
        useOidcStore().actions.value.setUser(updatedOidcUser);
      }
    }
  } catch (err) {
    if (err.message.includes("Network Error")) {
      return;
    } else {
      console.log(
        "refresh session or redirect: authenticate silent error",
        err,
      );
      await redirectLogin();
    }
  }
};

export const initializeAuthHooks = async () => {
  // Try to refresh token if expired and refreshing stopped
  // if fail => redirect to login page
  document.addEventListener("visibilitychange", async () => {
    const oidcStore = useOidcStore();
    // we only care when the user switches to the page.
    if (document.hidden === false) {
      if (oidcStore.accessToken) {
        return;
      }
      console.log(
        "Automatic silent renew stopped due to inactivity, restarting...",
      );
      await tryRefreshSessionOrRedirect();
    }
  });
  // before each request verify if token is still valid
  // try to renew it if not or redirect to login page
  rapsotecClient.interceptors.request.use(
    async (config) => {
      if (useOidcStore().state.value.token) {
        return config;
      }
      console.log("Token expired trying to reconnect...");
      await tryRefreshSessionOrRedirect();
      return config;
    },
    (error) => {
      console.error("Before request interceptor error", error);
      return Promise.reject(error);
    },
  );
  // On 401 error which means token is not expired but session expired
  // redirect to login page
  rapsotecClient.interceptors.response.use(
    (response) => response,
    (error) => {
      // case when accessToken still valid in time but session expired
      // and revoked all tokens
      if (
        error.status === 401 ||
        (error.response && error.response.status === 401)
      ) {
        redirectLogin();
      }
      return Promise.reject(error);
    },
  );
};
